<template>
	<v-col class="reward">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">List Reward</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-medal</v-icon>
			<div class="pl-2">Reward</div>
			<div class="px-2">/</div>
			<div>List Reward</div>
		</div>

		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab elevation="2" @click="showReward = 'rewardTitik'"><template v-if="showReward === 'rewardTitik'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Titik</v-tab>
							<v-tab @click="showReward = 'rewardPribadi'"><template v-if="showReward === 'rewardPribadi'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Pribadi</v-tab>
							<v-tab @click="showReward = 'rewardGrup'"><template v-if="showReward === 'rewardGrup'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Grup</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<template v-if="!loading">
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="showReward === 'rewardTitik'">
					<ListRewardTitik></ListRewardTitik>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="showReward === 'rewardPribadi'">
					<ListRewardPribadi></ListRewardPribadi>
				</div>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="showReward === 'rewardGrup'">
					<ListRewardGroup></ListRewardGroup>
				</div>
			</v-scroll-x-transition>
		</template>

		<template v-else>
			<v-row>
				<v-col cols="12" sm="12" md="12">
					<LoadData :loading="loading"></LoadData>
				</v-col>
			</v-row>
		</template>
	</v-col>
</template>

<script>
import { mapActions } from 'vuex'
import ListRewardTitik from './components/ListRewardTitik';
import ListRewardPribadi from './components/ListRewardPribadi';
import ListRewardGroup from './components/ListRewardGroup';

export default {
	components: {
		ListRewardTitik, ListRewardPribadi, ListRewardGroup
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			showReward: 'rewardTitik',
		}
	},
	computed: {
	},
	methods: {
		...mapActions('reward', ['getRewardTitik']),

		getData() {
			// this.loading = true
			this.getRewardTitik(this.queryString({limit:this.limit, page: this.page, params:this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				// this.loading = false
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `List Reward`)
		this.getData()
	}
};
</script>

